module.exports = __webpack_public_path__ + "assets/fc08f3cafbe7b445164f562411bcc664.png";